<template>
  <div class="modal show" role="dialog" aria-modal="true" @keydown.esc="cancel">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="cancel"></button>
        </div>
        <div class="modal-body">{{ message }}</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancel">{{ cancelText }}</button>
          <button type="button" class="btn btn-danger" ref="confirmButton" @click="confirm">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    title: { type: String, default: 'Confirm deletion' },
    message: { type: String, default: 'Are you sure you want to delete this item?' },
    confirmText: { type: String, default: 'Delete' },
    cancelText: { type: String, default: 'Cancel' },
  },
  emits: ['confirm', 'cancel'],
  mounted() {
    this.$refs.confirmButton.focus();
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },

    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
